const MICRO_UNITS_PER_DOLLAR = 1_000_000;
const SMALL_AMOUNT_THRESHOLD_DOLLARS = 0.01;
const USAGE_CURRENCY = 'USD';

export function formatMicroUsd(microUsd: number, language: string): string {
  const dollars = microUsd / MICRO_UNITS_PER_DOLLAR;
  const fractionDigits = dollars > 0 && dollars < SMALL_AMOUNT_THRESHOLD_DOLLARS ? 4 : 2;
  return new Intl.NumberFormat(language, {
    style: 'currency',
    currency: USAGE_CURRENCY,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(dollars);
}

export function microUsdToDollars(microUsd: number): number {
  return microUsd / MICRO_UNITS_PER_DOLLAR;
}

export function formatCompactNumber(value: number, language: string): string {
  return new Intl.NumberFormat(language, { notation: 'compact', maximumFractionDigits: 1 }).format(
    value
  );
}

export function formatPercent(ratio: number, language: string): string {
  return new Intl.NumberFormat(language, { style: 'percent', maximumFractionDigits: 0 }).format(
    ratio
  );
}

export function formatUsdRate(rate: string, language: string): string {
  return new Intl.NumberFormat(language, {
    style: 'currency',
    currency: USAGE_CURRENCY,
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(Number(rate));
}

const AXIS_SIGNIFICANT_DIGITS = 2;

export function formatAxisDollars(dollars: number, language: string): string {
  if (dollars === 0 || Math.abs(dollars) >= SMALL_AMOUNT_THRESHOLD_DOLLARS) {
    return formatMicroUsd(dollars * MICRO_UNITS_PER_DOLLAR, language);
  }
  return new Intl.NumberFormat(language, {
    style: 'currency',
    currency: USAGE_CURRENCY,
    maximumSignificantDigits: AXIS_SIGNIFICANT_DIGITS,
  }).format(dollars);
}
